// /app/frontend/src/components/frugal-v2/hooks/useSubscription.js
// Subscription status hook (80 lines)

import { useState, useEffect, useCallback } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

export const useSubscription = (token) => {
  const [status, setStatus] = useState(null);
  const [pricing, setPricing] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStatus = useCallback(async () => {
    if (!token) return;
    
    try {
      const response = await fetch(`${API}/api/v2/frugal/subscription/status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setStatus(data);
      }
    } catch (error) {
      console.error('Error fetching subscription status:', error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  const fetchPricing = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/v2/frugal/subscription/pricing`);
      if (response.ok) {
        const data = await response.json();
        setPricing(data);
      }
    } catch (error) {
      console.error('Error fetching pricing:', error);
    }
  }, []);

  const getPaymentLink = useCallback(async (plan = 'monthly') => {
    if (!token) return null;
    
    try {
      const response = await fetch(
        `${API}/api/v2/frugal/subscription/payment-link?plan=${plan}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      if (response.ok) {
        const data = await response.json();
        return data.url;
      }
    } catch (error) {
      console.error('Error getting payment link:', error);
    }
    return null;
  }, [token]);

  useEffect(() => {
    fetchStatus();
    fetchPricing();
  }, [fetchStatus, fetchPricing]);

  return {
    // Status
    status: status?.status || 'loading',
    daysRemaining: status?.days_remaining,
    daysUntilDeletion: status?.days_until_deletion,
    emailsEnabled: status?.emails_enabled ?? true,
    showUpgradeBanner: status?.show_upgrade_banner ?? false,
    isTrialExpired: status?.status === 'expired',
    isActive: status?.status === 'active',
    
    // Pricing
    pricing,
    monthlyPrice: pricing?.plans?.monthly?.amount || 2.99,
    yearlyPrice: pricing?.plans?.yearly?.amount || 29.99,
    yearlySavings: pricing?.plans?.yearly?.savings || '17%',
    
    // Actions
    getPaymentLink,
    refresh: fetchStatus,
    loading
  };
};

export default useSubscription;
